<template lang="pug">
    model-data-table(
            loading-text="Cargando órdenes de compra..."
            no-data-text="Sin órdenes de compra."
            no-search
            no-remove
            no-filter
            ref="table"
            v-bind="tableProps"
            @detail="submitShow"
            )
</template>

<script>
//-
import { ModelDataTable } from '@/components/reusable_components/next'
import pshOrderHeader from './pshOrderHeaderTableList'
import purchaseOrdersIncludes from '@/services/api/purchaseOrders/purchaseOrdersIncludes'
import PchOrderMdl from '@/models/Purchase/PchPurchaseOrder'
//-
export default {
    name: 'purchase-order-list',
    props: {},
    data: function() {
        return {
            headers: pshOrderHeader,
            providerId: 0,
        }
    },
    computed: {
        tableProps() {
            return {
                service: PchOrderMdl,
                paramFilter: {
                    pch_provider_id: this.providerId,
                },
                headers: this.headers,
            }
        },
    },
    methods: {
        //-
        setProviderId() {
            this.providerId = this.$route.params.id
        },

        /*
         *
         */
        submitShow(event) {
            this.$router.push(
                `/providers/${this.providerId}/purchase_orders/${event.item.id}`
            )
        },
    },
    components: {
        'model-data-table': ModelDataTable,
    },
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    beforeMount: function() {
        this.setProviderId()
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
.products-dialog-picker .full-width-datatable .v-table__overflow {
    max-height: 35vh;
    overflow-y: auto;
}
.v-dialog {
    background: white;
}
</style>
